'use client';
import { Image as SharedImage } from '@launchstore/shared-puck';
import type { ImageProps } from '@launchstore/shared-puck';
export const Image: any = SharedImage;
export type { ImageProps };
export default Image;
